import { Component, Inject, LOCALE_ID } from "@angular/core";
import { MobileWebViewService } from "src/app/services/mobile-web-view.service";
import { environment } from "src/environments/environment.staging";

@Component({
  selector: "escalation-page",
  templateUrl: "./escalation-page.component.html",
  styleUrl: "./escalation-page.component.scss",
})
export class EscalationPageComponent {
  isMobileWebView$ = this.mobileWebViewService.isMobileWebView$;
  links = environment.links;

  constructor(private mobileWebViewService: MobileWebViewService, @Inject(LOCALE_ID) private locale: string,
  ) { }
  get isAr() {
    return this.locale === "ar";
  }
}
